import React from 'react';
import  KannadaCCA1and22024  from 'views/KannadaCCA1and22024';
const BlogNewsroomPage = () => {
return <KannadaCCA1and22024/>
};
export default BlogNewsroomPage;